import type React from 'react';
import { type FunctionComponent, createContext } from 'react';

interface Props {
  triggerHotjarEvent?: (event: string) => void;
  children: React.ReactNode;
}

export const HotjarContext = createContext<{
  triggerHotjarEvent: Props['triggerHotjarEvent'];
}>({ triggerHotjarEvent: undefined });

export const HotjarProvider: FunctionComponent<Props> = ({
  children,
  triggerHotjarEvent,
}) => (
  <HotjarContext.Provider value={{ triggerHotjarEvent }}>
    {children}
  </HotjarContext.Provider>
);
